import axios from "axios";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { FaFileUpload } from "react-icons/fa";
import { IoMdCloseCircle } from "react-icons/io";
import { MdClose } from "react-icons/md";
import { RiEditFill } from "react-icons/ri";

const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/$/, "");
const BankDetailsEdit = ({ profiledate, editicon, sellerId }) => {
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm();
  const [save, setSave] = useState(false);
  const [getbankdetals, setGetbankdetals] = useState();
  const passbookFile = watch("passbook")?.[0];

  const onSubmit = (data) => {
    console.log("Bank Details Submitted:", data);
    const uploadedFile = data.passbook?.[0];
    if (uploadedFile) {
      console.log("Passbook File:", uploadedFile);
    }
    setSave(false);
  };

  const fetchBankDetails = async () => {
    try {
      const res = await axios.post(
        `${API_BASE_URL}/seller/get-bank-details`,
        {
          stripeBankId: profiledate.stripe_bank_id,
          stripeAccountId: profiledate.stripe_account_id,
        },
        {
          headers: {
            "Content-Type": "application/json",
            accept: "application/json",
            token:
              sessionStorage.getItem("accessToken") ||
              localStorage.getItem("accessToken"),
          },
        }
      );

      // console.log("Bank details:", res.data);
      setGetbankdetals(res.data.result);
    } catch (error) {
      console.error(
        "Error fetching bank details:",
        error.response?.data || error.message
      );
    }
  };

  useEffect(() => {
    fetchBankDetails();
  }, []);

  // Preload existing bank details into the form whenever edit mode opens
  useEffect(() => {
    if (save && getbankdetals) {
      setValue("bankName", getbankdetals.bank_name || "");
      setValue("beneficiaryName", getbankdetals.account_holder_name || "");
      setValue("accountNumber", getbankdetals.last4 || "");
      setValue("ifscOrSwift", getbankdetals.routing_number || "");
    }
  }, [save, getbankdetals, setValue]);

  return (
    <div>
      <div className="p-0  sm:p-5 ">
        <div className="flex flex-row justify-between border-b-2">
          <p className="text-lg text-[#095228] font-medium">
            Bank Account Details
          </p>
          {!sellerId &&
            (save === true ? (
              <button
                onClick={() => setSave(false)}
                className="text-xs m-1 bg-green-800 py-1 rounded-xl px-3 font-medium text-white file:"
              >
                Close
              </button>
            ) : (
              <button onClick={() => setSave(true)} className="text-xs">
                <RiEditFill className="text-[18px]" />
              </button>
            ))}
        </div>
        {save === true ? (
          <div className="mt-6">
            <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
              <div>
                <label className="block text-sm font-medium mb-1">
                  Bank Name
                </label>
                <input
                  type="text"
                  {...register("bankName", { required: true })}
                  placeholder="Enter Your Bank Name"
                  className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-green-600"
                />
                {errors.bankName && (
                  <p className="text-sm text-red-500">Bank Name is required</p>
                )}
              </div>

              <div>
                <label className="block text-sm font-medium mb-1">
                  Beneficiary Name
                </label>
                <input
                  type="text"
                  {...register("beneficiaryName", { required: true })}
                  placeholder="Enter Your Beneficiary Name"
                  className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-green-600"
                />
                {errors.beneficiaryName && (
                  <p className="text-sm text-red-500">
                    Beneficiary Name is required
                  </p>
                )}
              </div>

              <div>
                <label className="block text-sm font-medium mb-1">
                  Account Number
                </label>
                <input
                  type="text"
                  {...register("accountNumber", { required: true })}
                  placeholder="Enter Your Account Number"
                  className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-green-600"
                />
                {errors.accountNumber && (
                  <p className="text-sm text-red-500">
                    Account Number is required
                  </p>
                )}
              </div>

              <div>
                <label className="block text-sm font-medium mb-1">
                  IFSC or SWIFT Code
                </label>
                <input
                  type="text"
                  {...register("ifscOrSwift", { required: true })}
                  placeholder="Enter Your IFSC or SWIFT Code"
                  className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-green-600"
                />
                {errors.ifscOrSwift && (
                  <p className="text-sm text-red-500">
                    IFSC or SWIFT Code is required
                  </p>
                )}
              </div>

              <div>
                <label className="block text-sm font-medium mb-1">
                  Passbook/Cancelled Cheque
                </label>

                <div className="flex items-center gap-3">
                  <div className="flex items-center w-full border rounded-lg px-3 py-2 focus-within:ring-2 focus-within:ring-green-600">
                    <input
                      type="file"
                      accept="application/pdf"
                      id="passbook-upload"
                      {...register("passbook", { required: true })}
                      className="hidden"
                    />

                    <label
                      htmlFor="passbook-upload"
                      className="flex-grow cursor-pointer text-sm text-gray-500 truncate"
                    >
                      {passbookFile
                        ? passbookFile.name
                        : "Upload Passbook or Cheque"}
                    </label>

                    <label htmlFor="passbook-upload" className="cursor-pointer">
                      <FaFileUpload className="text-[25px]" />
                    </label>
                  </div>

                  {passbookFile && (
                    <button
                      type="button"
                      onClick={() => setValue("passbook", null)}
                      className="text-red-600 hover:text-red-800 text-lg"
                      title="Remove file"
                    >
                      <MdClose />
                    </button>
                  )}
                </div>

                {errors.passbook && (
                  <p className="text-sm text-red-500">
                    Passbook or Cancelled Cheque is required
                  </p>
                )}
              </div>

              <button
                type="submit"
                className="mt-4 px-4 py-2 bg-green-700 text-white rounded-full hover:bg-green-800"
              >
                Save
              </button>
            </form>
          </div>
        ) : (
          <div className="space-y-5 mt-5">
            <div>
              <p className="text-gray-500 font-medium text-[14px]">
                Beneficiary Name
              </p>
              <p className="text-[14px] font-medium">
                {getbankdetals?.account_holder_name || "xxxxxxx"}
              </p>
            </div>
            <div>
              <p className="text-gray-500 font-medium text-[14px]">Bank Name</p>
              <p className="text-[14px] font-medium">
                {" "}
                {getbankdetals?.bank_name || "xxxxxxx"}
              </p>
            </div>
            <div>
              <p className="text-gray-500 font-medium text-[14px]">
                Account Number
              </p>
              <p className="text-[14px] font-medium">
                {" "}
                {getbankdetals?.last4 || "xxxxxxx"}
              </p>
            </div>
            <div>
              <p className="text-gray-500 font-medium text-[14px]">
                IFSC or SWIFT Code
              </p>
              <p className="text-[14px] font-medium">
                {getbankdetals?.routing_number || "xxxxxxx"}
              </p>
            </div>
            <div className=" mt-5">
              <span className="text-gray-500 font-medium">
                Passbook/Cancelled Cheque
              </span>
              <div className="flex items-center gap-2 mt-1">
                <a
                  href={`/image/backgroundprofile.png`}
                  className="text-blue-600 underline text-sm"
                >
                  {"xxxxxxx"}
                </a>
                <button className="text-red-500 text-lg">
                  <IoMdCloseCircle />
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default BankDetailsEdit;
